import { Component, Inject } from '@angular/core';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { InputComponent } from '../../../../shared/components/input/input.component';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Local } from '../../../../shared/models/local';
import { LocalService } from '../../../../shared/services/local.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { ToastState as ts } from '../../../../shared/enums/toast-state.enum';

@Component({
  selector: 'app-dialog-local',
  imports: [ModalComponent, InputComponent, ReactiveFormsModule],
  templateUrl: './dialog-local.component.html',
  styleUrl: './dialog-local.component.scss',
})
export class DialogLocalComponent {
  form: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<DialogLocalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      local: Local | null;
    },
    private fb: FormBuilder,
    private localService: LocalService,
    private toast: ToastService,
  ) {
    this.form = this.fb.group({
      id: [data?.local?.id ?? 0],
      nome: [
        data?.local?.nome ?? '',
        [Validators.required, Validators.maxLength(12)],
      ],
    });
  }

  onSave(formData: any) {
    const dto: Local = {
      id: formData.id,
      nome: formData.nome,
    };
    if (dto.id > 0) {
      this.update(dto);
    } else {
      this.insert(dto);
    }
  }

  private insert(data: Local) {
    this.localService.insert(data).subscribe({
      next: (result) => {
        if (result.success) {
          this.toast.showToast(ts.success, 'Local criado com sucesso!');
          this.dialogRef.close(result.content);
        }
      },
      error: (e) => {
        this.toast.showToast(ts.error, e.error[0]);
        this.dialogRef.close();
      },
    });
  }

  private update(data: Local) {
    this.localService.update(data).subscribe({
      next: (result) => {
        if (result.success) {
          this.toast.showToast(ts.success, 'Local atualizado');
          this.dialogRef.close(result.content);
        } else {
          this.toast.showToast(ts.error, result.messages[0]);
        }
      },
      error: (e) => {
        this.toast.showToast(ts.error, e.error[0]);
        this.dialogRef.close();
      },
    });
  }
}
